export default function Privacy() {
  return (
    <div className="min-h-screen bg-black py-16 px-4" dir="rtl">
      <div className="max-w-4xl mx-auto text-white">
        <h1 className="text-4xl font-black mb-8">سياسة الخصوصية</h1>
        <div className="space-y-6 text-neutral-300 leading-loose text-lg">
          <p>
            في برولاكس، نحن ملتزمون بحماية خصوصية زبائننا. تشرح هذه السياسة كيفية جمعنا
            واستخدامنا للمعلومات الشخصية التي تقدمها لنا عند استخدام موقعنا.
          </p>
          <p>
            <strong className="text-white">ما المعلومات التي نجمعها؟</strong><br />
            نقوم بجمع الاسم، رقم الهاتف، وعنوان الشحن عند تقديم طلب.
            نستخدم هذه البيانات فقط لمعالجة طلبك وتوصيله إليك.
          </p>
          <p>
            <strong className="text-white">كيف نستخدم معلوماتك؟</strong><br />
            نستخدم معلوماتك لتأكيد الطلب، تحديثك بحالة الشحن، وتحسين تجربتك. لا نبيع أو نشارك
            بياناتك مع أطراف خارجية لأغراض تسويقية.
          </p>
          <p>
            <strong className="text-white">الأمان</strong><br />
            نطبق إجراءات أمنية مناسبة لحماية معلوماتك من الوصول غير المصرح به أو التعديل.
          </p>
          <p>
            إذا كانت لديك أي استفسارات حول سياسة الخصوصية، يُرجى التواصل معنا عبر صفحة "اتصل
            بنا".
          </p>
        </div>
      </div>
    </div>
  );
}